/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { schedule } from '@ember/runloop';
import { durationBetween } from 'my-phorest/utils/local-datetime-helpers';

export default class ClientChatComponent extends Component {
  @service twoWayChat;
  @service timers;
  @service branchTime;
  @service session;
  @service intl;

  @tracked message = '';
  @tracked lastMessageId = '';
  @tracked formattedTime = '';

  constructor() {
    super(...arguments);

    if (this.twoWayChat.selectedConversation.channel === 'WHATSAPP') {
      this.updateCountdown();
      this.timers.registerTimer({
        action: () => {
          this.updateCountdown();
        },
        every: 1000,
        destroyable: this,
      });
    }
  }

  get smsCount() {
    return Math.ceil(this.message.length / this.perMessageLimit);
  }

  get perMessageLimit() {
    return /\p{Extended_Pictographic}/u.test(this.message) ? 70 : 160;
  }

  get isWindowOpen() {
    return this.twoWayChat.selectedConversation.whatsappWindowInfo.isWindowOpen;
  }

  get isLastMessageSentTemplate() {
    return (
      this.twoWayChat.lastMessage?.messageType ===
      'SALON_OUTBOUND_TEMPLATE_MESSAGE'
    );
  }

  updateCountdown() {
    if (this.isWindowOpen) {
      const windowExpiresAt =
        this.twoWayChat.selectedConversation.whatsappWindowInfo.windowExpiresAt;

      const duration = durationBetween(
        windowExpiresAt,
        this.branchTime.dateAndTime
      );

      if (!duration || duration.asSeconds() <= 0) {
        this.twoWayChat.getWhatsappConversationTask.perform();
        return;
      }

      this.formattedTime = this.#formatDuration(duration);
    }
  }

  @action
  afterFetchMore() {
    schedule('afterRender', () => {
      const element = document.querySelector(
        `[data-js-message-id='${this.lastMessageId}']`
      );
      element?.scrollIntoView();
    });
  }

  #formatDuration(duration) {
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.asMinutes());
    const seconds = Math.floor(duration.asSeconds());

    if (hours > 0) {
      return this.intl.t('two-way-chat.chat-window-ends-in.hours', {
        hours,
      });
    }

    if (minutes > 0) {
      return this.intl.t('two-way-chat.chat-window-ends-in.minutes', {
        minutes,
      });
    }

    return this.intl.t('two-way-chat.chat-window-ends-in.seconds', {
      seconds,
    });
  }
}
